import {type UseQueryResult, useQuery} from '@tanstack/react-query';

import type {SlackShoutouts} from '../types';
import {getRequest} from '../utils/httpClient';

/** Hook for `GET /api/admin/slack/shoutouts`: idle until a start date is chosen. */
export const useSlackShoutouts = (since: string | null): UseQueryResult<SlackShoutouts> =>
    useQuery({
        queryKey: ['slackShoutouts', since],
        queryFn: () =>
            getRequest<SlackShoutouts>(
                `/api/admin/slack/shoutouts?since=${encodeURIComponent(since ?? '')}`,
            ),
        enabled: since !== null,
        staleTime: 60 * 1000,
    });
